'use client';

import { useMemo, useState } from 'react';
import { useAppSelector } from '@/app/lib/store/hooks';
import { InvalidDataError } from '@/app/lib/errors/shared';
import { ConfigUrlData } from '@/app/lib/schemas/types/app-types';
import CardFooterView from './card-footer-view';

interface Props {
  markdown: string;
  configUrlData: ConfigUrlData;
  onShowSolution: (baseUrl: string) => void;
}

const CardFooterFeaturedContainer = ({
  markdown,
  configUrlData,
  onShowSolution
}: Props) => {
  const { topicSlug } = configUrlData;
  const branches = useAppSelector(state => state.navigation.branches);

  const [showAnswer, setShowAnswer] = useState(false);

  const baseUrl = useMemo(() => {
    const branchSlug = branches.find(branch =>
      branch.topics.find(topic => topic.slug === topicSlug)
    )?.slug;

    if (!branchSlug)
      throw new InvalidDataError('Не удалось сконфигурировать url');

    return `/${branchSlug}/${topicSlug}/`;
  }, [branches, topicSlug]);

  return (
    <CardFooterView
      markdown={markdown}
      showAnswer={showAnswer}
      onToggleAnswer={() => setShowAnswer(prev => !prev)}
      onNavigateToSolution={() => onShowSolution(baseUrl)}
    />
  );
};
export default CardFooterFeaturedContainer;
